import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const blogImages = [
  'https://images.pexels.com/photos/3735218/pexels-photo-3735218.jpeg',
  'https://images.pexels.com/photos/343457/pexels-photo-343457.jpeg',
  'https://images.pexels.com/photos/459411/pexels-photo-459411.jpeg',
  'https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg',
  'https://images.pexels.com/photos/209251/pexels-photo-209251.jpeg',
];

const InsightsPage = () => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [postsRes, catsRes] = await Promise.all([
          fetch(`${API_URL}/api/blog/posts`),
          fetch(`${API_URL}/api/blog/categories`),
        ]);
        const postsData = await postsRes.json();
        const catsData = await catsRes.json();
        setPosts(postsData);
        setCategories(catsData);
        console.log('ASJCSBJDSVJSDJSV=============CATEGORIESDATA>', catsData)
      } catch (err) {
        console.error('Failed to fetch blog data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredPosts = selectedCategory === 'All' ? posts : posts.filter(p => p.category === selectedCategory);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  const getImage = (post, index) => post.image_url || blogImages[index % blogImages.length];

  return (
    <main className="bg-white">
      {/* Hero */}
      <section className="pt-28 lg:pt-36 pb-16 bg-[#0a1628]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-4">News & Insights</p>
            <h1 className="text-4xl lg:text-5xl font-light text-white mb-6">
              Latest <span className="font-semibold">Updates</span>
            </h1>
            <p className="text-lg text-gray-400">
              Expert perspectives on e-waste management, sustainability, and the circular economy.
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-6 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-2" data-testid="insights-categories">
            <button onClick={() => setSelectedCategory('All')}
              data-testid="insights-cat-all"
              className={`px-4 py-2 text-sm font-medium transition-colors ${selectedCategory === 'All' ? 'bg-[#0a1628] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
              All
            </button>
            {categories.map((cat) => (
              <button key={cat} onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 text-sm font-medium transition-colors ${selectedCategory === cat ? 'bg-[#0a1628] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
                {cat.split(':')[0]}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Posts */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-8 h-8 border-2 border-[#4fd1c5] border-t-transparent rounded-full animate-spin" />
            </div>
          ) : filteredPosts.length === 0 ? (
            <div className="text-center py-20 text-gray-400">No posts found.</div>
          ) : (
            <>
              {/* Featured Post */}
              <div className="mb-16">
                <div className="grid lg:grid-cols-2 gap-0 border border-gray-200 overflow-hidden">
                  <div className="aspect-video lg:aspect-auto overflow-hidden">
                    <img src={getImage(filteredPosts[0], 0)} alt={filteredPosts[0].title} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                  </div>
                  <div className="p-8 lg:p-12 flex flex-col justify-center bg-[#f8fafc]">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-[#4fd1c5] text-xs font-semibold uppercase tracking-wider">{filteredPosts[0].category?.split(':')[0]}</span>
                      <span className="text-gray-400 text-sm">{formatDate(filteredPosts[0].date)}</span>
                    </div>
                    <h2 className="text-2xl lg:text-3xl font-semibold text-[#0a1628] mb-4">{filteredPosts[0].title}</h2>
                    <p className="text-gray-500 mb-6">{filteredPosts[0].excerpt}</p>
                    {filteredPosts[0].source === 'rss' && filteredPosts[0].source_url ? (
                      <a href={filteredPosts[0].source_url} target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-[#4fd1c5] font-semibold" data-testid="insights-featured-link">
                        Read Full Article <ArrowRight className="w-4 h-4" />
                      </a>
                    ) : (
                      <Link to={`/insights/${filteredPosts[0].id}`} className="inline-flex items-center gap-2 text-[#4fd1c5] font-semibold"
                        data-testid="insights-featured-link">
                        Read More <ArrowRight className="w-4 h-4" />
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {/* Grid */}
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="insights-grid">
                {filteredPosts.slice(1).map((post, i) => (
                  <article key={post.id} className="group border border-gray-200 overflow-hidden hover:border-[#4fd1c5] transition-colors">
                    <div className="aspect-video overflow-hidden">
                      <img src={getImage(post, i + 1)} alt={post.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500" />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="text-[#4fd1c5] text-xs font-semibold uppercase">{post.category?.split(':')[0]}</span>
                        <span className="text-gray-400 text-xs">{formatDate(post.date)}</span>
                      </div>
                      <h3 className="font-semibold text-[#0a1628] mb-3 group-hover:text-[#4fd1c5] transition-colors">{post.title}</h3>
                      {post.source === 'rss' && post.source_url ? (
                        <a href={post.source_url} target="_blank" rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 text-sm font-semibold text-[#4fd1c5]">
                          Read Article <ArrowUpRight className="w-4 h-4" />
                        </a>
                      ) : (
                        <Link to={`/insights/${post.id}`} className="inline-flex items-center gap-1 text-sm font-semibold text-[#4fd1c5]">
                          Read More <ArrowUpRight className="w-4 h-4" />
                        </Link>
                      )}
                    </div>
                  </article>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-16 lg:py-24 bg-[#0a1628]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-light text-white mb-6">Stay <span className="font-semibold">Informed</span></h2>
          <p className="text-gray-400 mb-8">Get the latest insights delivered to your inbox.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto">
            <input type="email" placeholder="Enter your email" className="flex-1 px-5 py-3 bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-[#4fd1c5]" />
            <button className="inline-flex items-center justify-center gap-2 bg-[#4fd1c5] hover:bg-[#38b2ac] text-[#0a1628] px-6 py-3 font-semibold transition-colors">
              Subscribe <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default InsightsPage;
